import { FC, useCallback, useState } from "react"
import DeleteItemDialog from "src/components/shared/DeleteItemDialog"
import { IPayment } from "src/domain/entities"
import { paymentDeleteService } from "src/domain/services/payment/paymentDeleteService"
import { useAuth } from "src/hooks"
import { getErrorMessage } from "src/utils/helpers"

interface Props {
	payment: IPayment
	isOpen: boolean
	setIsOpen: (isOpen: boolean) => void
	onSuccess?: () => void
}

export const PaymentDeleteDialogController: FC<Props> = ({
	isOpen,
	setIsOpen,
	payment,
	onSuccess,
}) => {
	const { token } = useAuth()
	const [isLoading, setIsLoading] = useState(false)
	const [errorMessage, setErrorMessage] = useState<string | null>(null)

	const handlePaymentDelete = useCallback(async () => {
		try {
			setIsLoading(true)
			await paymentDeleteService({ id: payment.id }, token)
			setIsOpen(false)
			onSuccess && onSuccess()
		} catch (err) {
			setErrorMessage(getErrorMessage(err))
		} finally {
			setIsLoading(false)
		}
	}, [payment, setIsOpen, token, onSuccess])

	return (
		<DeleteItemDialog
			title={`Delete Payment: ${payment.paymentAmount}`}
			isOpen={isOpen}
			onCancel={() => {
				setIsOpen(false)
				setErrorMessage(null)
			}}
			onDelete={handlePaymentDelete}
			isLoading={isLoading}
			errorMessage={errorMessage}
		/>
	)
}
